"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlatformFunction = usePlatformFunction;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const useFunctionClient_1 = require("./useFunctionClient");
/**
 * Calls `storage.executeFunction` and returns an SWR response. SWR middleware `laggy` is used to make flipping
 * between pages look better, this is done by keeping previously loaded data while new data is loading.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param functionName - platform function name, this is optional, if not set backend will not be called and result will not be returned
 * @param params - optional params to pass to `useFunctionClient`, this is optional
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object, can be used to remove the custom `laggy` middleware
 */
function usePlatformFunction(functionName, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
params, baseUrl, tokenProvider, config) {
    const storage = (0, useFunctionClient_1.useFunctionClient)(baseUrl, tokenProvider);
    return (0, swr_1.default)(functionName ? ['/platform/api/v1/function', functionName, params] : null, async () => {
        return functionName ? storage.executeFunction({ functionName, params }) : undefined;
    }, config ?? {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
}
